export default __webpack_public_path__ + "static/media/rice.6786d387.png";